import { ThemeBgSensitive } from '@mentimeter/ragnar-ui/themes';
import type { ReactNode } from 'react';
import { useQuestion, useTheme } from '../data-mediation';

export const SfinxThemeBgSensitiveDatahandler = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { theme_settings } = useQuestion();
  const { background_color } = useTheme();
  const themeBg = theme_settings?.background_color ?? background_color;

  return <ThemeBgSensitive themeBg={themeBg}>{children}</ThemeBgSensitive>;
};
